module.exports = __webpack_public_path__ + "fonts/title.1726685c.ttf";